// // import { saveAs } from "file-saver";

// // export async function downloadProgressCSV(report) {
// //   const { unparse } = await import("papaparse");

// //   const rows = report.list.map((r) => ({
// //   Код:
// //     Дугаар: r.number,
// //     "Зарагдсан эсэх": r.is_sold ? "Тийм" : "Үгүй",
// //     // "Тасалбар ID": r.ticket_id ?? "",
// //     Утас: r.phone_number ?? "",
// //     "Авсан огноо": r.purchased_at
// //       ? new Date(r.purchased_at).toLocaleString()
// //       : "",
// //   }));

// //   const csv = unparse(rows, { header: true });
// //   const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
// //   saveAs(blob, "lottery-progress.csv");
// // }

// import { saveAs } from "file-saver";

// export async function downloadProgressCSV(report) {
//   const { unparse } = await import("papaparse");

//   const { meta, totals } = report;

//   const summaryRows = [
//     { key: "Сугалааны нэр", value: meta?.title || "" },
//     { key: "Prefix", value: meta?.ticket_prefix || "" },
//     { key: "Төлөв", value: meta?.status || "" },
//     { key: "Харагдах байдал", value: meta?.visibility || "" },
//     { key: "", value: "" },
//     { key: "Нийт дугаар", value: totals?.total ?? 0 },
//     { key: "Зарагдсан", value: totals?.sold ?? 0 },
//     { key: "Зарагдаагүй", value: totals?.unsold ?? 0 },
//     { key: "", value: "" },
//     { key: "", value: "" },
//   ];

//   const dataRows = (report.list || []).map((r) => ({
//     Код:
//       r.number && r.number.includes("-") ? r.number.split("-").pop() : r.number,
//     Дугаар: r.number,
//     "Зарагдсан эсэх": r.is_sold ? "Тийм" : "Үгүй",
//     Утас: r.phone_number ?? "",
//     "Авсан огноо": r.purchased_at
//       ? new Date(r.purchased_at).toLocaleString()
//       : "",
//   }));

//   // PapaParse нэг sheet-д л ажиллана. Тиймээс хоёр хэсгийг нийлүүлж бичнэ:
//   const csvSummary = unparse(summaryRows, { header: true });
//   const csvData = unparse(dataRows, { header: true });

//   // Хооронд нь хоосон мөрнүүд байгаа тул шууд нийлүүлж болно:
//   const csv = `${csvSummary}\n${csvData}`;

//   const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
//   saveAs(blob, "lottery-progress.csv");
// }

import { saveAs } from "file-saver";

export async function downloadProgressCSV(report) {
  const ExcelJS = (await import("exceljs")).default;

  const wb = new ExcelJS.Workbook();
  const ws = wb.addWorksheet("Lottery Progress");

  // === Summary block ===
  const { meta, totals } = report;

  const summary = [
    ["Сугалааны нэр", meta?.title || ""],
    ["Код", meta?.ticket_prefix || ""],
    ["Төлөв", meta?.status || ""],
    ["Харагдах байдал", meta?.visibility || ""],
    ["", ""],
    ["Нийт дугаар", totals?.total ?? 0],
    ["Зарагдсан", totals?.sold ?? 0],
    ["Зарагдаагүй", totals?.unsold ?? 0],
  ];

  ws.addRows(summary);
  ws.getRow(1).font = { bold: true };
  ws.getRow(7).font = { bold: true };

  // Хооронд нь хоосон мөр
  ws.addRow(["", ""]);
  ws.addRow(["", ""]);

  // === Data header ===
  const headerRowIdx = ws.lastRow.number + 1;
  ws.getCell(`A${headerRowIdx}`).value = "Дугаар";
  ws.getCell(`B${headerRowIdx}`).value = "Зарагдсан эсэх";
  ws.getCell(`C${headerRowIdx}`).value = "Утас";
  ws.getCell(`D${headerRowIdx}`).value = "Авсан огноо";
  ws.getRow(headerRowIdx).font = { bold: true };

  // === Data rows ===
  const data = (report.list || []).map((r) => [
    // Код (prefix-салгасан suffix)
    r.number && r.number.includes("-") ? r.number.split("-").pop() : r.number,
    r.is_sold ? "Тийм" : "Үгүй",
    r.phone_number ?? "",
    r.purchased_at ? new Date(r.purchased_at).toLocaleString() : "",
  ]);

  ws.addRows(data);

  // Column widths
  const widths = [10, 14, 16, 22];
  widths.forEach((w, i) => (ws.columns[i].width = w));

  const buf = await wb.xlsx.writeBuffer();

  const prefix = meta?.ticket_prefix || "LOTTERY";
  const now = new Date();
  const timestamp = `${now.getFullYear()}${String(now.getMonth() + 1).padStart(
    2,
    "0"
  )}${String(now.getDate()).padStart(2, "0")}-${String(now.getHours()).padStart(
    2,
    "0"
  )}${String(now.getMinutes()).padStart(2, "0")}${String(
    now.getSeconds()
  ).padStart(2, "0")}`;
  const filename = `${prefix}-${timestamp}.xlsx`;

  const blob = new Blob([buf], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  saveAs(blob, filename);
}
